import {createMuiTheme} from "@material-ui/core/styles/index";

const theme = createMuiTheme({
  overrides: {
    // Name of the component️ / style sheet
    MuiChip: {
      // Name of the rule
      root: {
        // Some CSS
        backgroundColor: 'black',
        border: '1px solid black',
        color: 'white',
        height: 26,
        marginTop: '3px',
        marginRight: '3px',
      },
      deletable: {
        '&:focus': {
          backgroundColor: 'black',
          color: 'white',
        }
      },
      deleteIcon: {
        height: 15,
        color: 'white',
        '&:hover': {
          height: 18,
          color: 'white',
        },

      },
      label: {
        paddingLeft: '8px',
        paddingRight: '8px',
        fontSize: '10px',
      }
    },
    MuiLinearProgress: {
      colorPrimary: {
        backgroundColor: 'rgba(0,0,0,0.3)'
      },
      barColorPrimary: {
        backgroundColor: 'rgba(0,0,0,1)'
      }
    },
    MuiCircularProgress: {
      colorPrimary: {
        color: 'rgba(0,0,0,0.75)',
      }
    },
    MuiInput: {
      input: {
        fontSize: '12px',
        padding: '12px 0 0',
      },
      underline: {
        '&:before': {
          borderBottom: '1px solid black',
        },
        '&:after': {
          borderBottom: '1px solid black',
        }
      }
    },
    MuiIconButton: {
      root: {
        width: '',
        height: '',
        "&:hover": {
          backgroundColor: 'none',
        }
      }
    },
    MuiButton: {
      root: {
        transition: 'none',
        fontFamily: 'Helvetica Neue',
        fontWeight: '500',
        fontSize: '12px',
      },
      contained: {
        boxShadow: 'none',
        borderRadius: '0',
      },
      text: {
        '&:hover': {
          background: 'rgba(0,0,0,0.2)',
        }
      },
      containedPrimary: {
        backgroundColor: 'black',
        border: '1px solid black',
        '&:hover': {
          backgroundColor: 'white',
          color: 'black',
        }
      }
    }

  },
});

export default theme;